import CryptoJS from 'crypto-js';
import moment from 'moment';

export const encryptData = (text) => {
    try {
        const key_hex = process.env.REACT_APP_KEY;
        const iv_hex = process.env.REACT_APP_IV;

        const key = CryptoJS.enc.Hex.parse(key_hex);
        const iv = CryptoJS.enc.Hex.parse(iv_hex);

        const encrypted = CryptoJS.AES.encrypt(text, key, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
        return encrypted.toString();
    } catch (error) {
        console.error("encryptData Exception = ", error);
        return false;
    }
};

export const decryptData = (encryptedText) => {
    const key = CryptoJS.enc.Hex.parse(process.env.REACT_APP_KEY);
    const iv = CryptoJS.enc.Hex.parse(process.env.REACT_APP_IV);

    const decrypted = CryptoJS.AES.decrypt(encryptedText, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
};


export function capitalizeFirstLetter(str) {
    if (!str) return str; // Return if the string is empty
    return str.charAt(0).toUpperCase() + str.slice(1);
}


export const replaceUnderScoreWithSpace = (str = "") => {
    return str.split('_').map(word => capitalizeFirstLetter(word)).join(' ')
}


export function calculateAge(dob) {
    const birthDate = new Date(dob);
    const today = new Date();

    let age = today.getFullYear() - birthDate.getFullYear();

    // Check if the birthday has not yet occurred this year
    if (
        today.getMonth() < birthDate.getMonth() ||
        (today.getMonth() === birthDate.getMonth() && today.getDate() < birthDate.getDate())
    ) {
        age--;
    }

    return age;
}

export function getWAMessageDetails(data) {
    if (!data || !Array.isArray(data)) return null;

    const itemsWithSentTime = data.filter(item => 
        item.WASentTime && item.WASentTime !== '0000-00-00 00:00:00'
    );

    if (itemsWithSentTime.length === 0) return null;

    const latestItem = itemsWithSentTime.reduce((latest, current) => {
        return moment(current.WASentTime).isAfter(moment(latest.WASentTime)) ? current : latest;
    }, itemsWithSentTime[0]);

    const sentTime = moment(latestItem?.WASentTime);
    const replyTime = moment(latestItem?.WAReplyTime);
    const messageResponse = latestItem?.WAMessageResponse?.trim();

    if (!sentTime.isValid()) return null;

    return (
        <div className="tw-space-y-1">
            <div className="tw-flex tw-flex-wrap tw-gap-x-4 tw-gap-y-1 tw-text-xs">
                <span className="tw-flex tw-items-center tw-gap-1">
                    <i className="bi bi-send tw-text-blue-500"></i>
                    <span className="tw-font-medium tw-text-gray-700">Sent:</span>
                    <span className="tw-text-gray-600">{sentTime.format('D MMM, YY h:mm A')}</span>
                </span>
                
                {replyTime.isValid() && latestItem?.WAReplyTime !== '0000-00-00 00:00:00' && (
                    <span className="tw-flex tw-items-center tw-gap-1">
                        <i className="bi bi-reply tw-text-green-500"></i>
                        <span className="tw-font-medium tw-text-gray-700">Replied:</span>
                        <span className="tw-text-gray-600">{replyTime.format('D MMM, YY h:mm A')}</span>
                    </span>
                )}
                {messageResponse && (
                    <div className="tw-flex tw-items-start tw-gap-1">
                        <i className="bi bi-chat-quote tw-text-gray-400 tw-flex-shrink-0"></i>
                        <span className="tw-font-medium tw-text-gray-700 tw-text-xs">Response:</span>
                        <span className="tw-text-gray-600 tw-text-xs tw-break-words">{messageResponse}</span>
                    </div>
                )}
            </div>
            
        </div>
    );
}


export function formatDateYmd(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}